export function toFixedNoRounding(number: number, precision: number) {
	const factor = Math.pow(10, precision);
	const roundedValue = Math.floor(number * factor) / factor;
	return roundedValue.toFixed(precision);
}